module.exports = __webpack_public_path__ + "static/media/1001163DO.733f079b.jpg";